module.exports = __webpack_public_path__ + "static/swaps-8143f6bc313c5d2b06a1df7403ccf540.jpg";